import * as t from 'io-ts';

export const timezones = t.type({
  value: t.string,
  label: t.string,
});

export const timezonesArray = t.array(timezones);
